//
// README - Beta Component
//
// This component is marked "beta" and will go through some iterations
// before landing at a final solution. Please reach out to the Cadence team
// if you intend to use this in the meantime and we'll help you out!
//

import React from 'react';
import { RCButton } from '../';

export interface RCAddToCartProps {
  onClick: () => void;
  inCart?: boolean;
  addingToCart?: boolean;
  disabled?: boolean;
}

export function RCAddToCart({
  onClick,
  inCart = false,
  addingToCart = false,
  disabled = false,
}: RCAddToCartProps) {
  function buttonText() {
    if (addingToCart) {
      return 'Adding to cart...';
    }

    if (inCart) {
      return 'In Cart';
    }

    return 'Add to Cart';
  }

  return (
    <RCButton
      onClick={onClick}
      disabled={addingToCart || disabled}
      size="large"
      variant="secondary"
    >
      {buttonText()}
    </RCButton>
  );
}
